module.exports = __webpack_public_path__ + "img/gznz.464e6c17.png";